import { vgaPalette } from './palette.js';

export class Canvas {
  constructor(size = 30) {
    this.size = size;
    this.data = Array.from({ length: size }, () => Array(size).fill(null));
    this.element = document.getElementById('canvas');
    this.isDrawing = false;
  }

  render() {
    this.element.innerHTML = '';
    for (let row = 0; row < this.size; row++) {
      for (let col = 0; col < this.size; col++) {
        const div = document.createElement('div');
        div.className = 'pixel';
        div.dataset.row = row;
        div.dataset.col = col;
        const val = this.data[row][col];
        div.style.backgroundColor = val === null ? 'transparent' : vgaPalette[val];
        this.element.appendChild(div);
      }
    }
  }

  clear() {
    for (let row = 0; row < this.size; row++) {
      for (let col = 0; col < this.size; col++) {
        this.data[row][col] = null;
      }
    }
    this.render();
  }

  setPixel(row, col, colorIndex) {
    if (row >= 0 && row < this.size && col >= 0 && col < this.size) {
      this.data[row][col] = colorIndex;
    }
  }

  getPixel(row, col) {
    if (row >= 0 && row < this.size && col >= 0 && col < this.size) {
      return this.data[row][col];
    }
    return null;
  }

  generateSVG() {
    let svg = `<svg width="100%" height="100%" viewBox="0 0 ${this.size} ${this.size}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">\n`;
    for (let y = 0; y < this.size; y++) {
      let x = 0;
      while (x < this.size) {
        const color = this.data[y][x];
        if (color === null) {
          x++;
          continue;
        }
        let length = 1;
        while (x + length < this.size && this.data[y][x + length] === color) length++;
        svg += `<rect x="${x}" y="${y}" width="${length}" height="1.1" fill="${vgaPalette[color]}" />\n`;
        x += length;
      }
    }
    svg += '</svg>';
    return svg;
  }
} 